import { forwardRef } from "react";

const StampDropdownItem = forwardRef<
  HTMLDivElement,
  { image: string; label: string }
>(({ image, label, ...others }: { image: string; label: string }, ref) => (
  <div
    ref={ref}
    {...others}
    style={{ display: "flex", alignItems: "center", gap: 5 }}>
    <img src={`data:image/png;base64, ${image}`} alt="" height="60" />
    <span>{label}</span>
  </div>
));

export default StampDropdownItem;
